import { Modal, Button, DatePicker, Form, Upload, UploadProps } from "antd";
import { useEffect, useRef, useState } from "react";
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";
import { useNavigate } from "react-router-dom";
// --------------------- Import dayJS ---------------------

import "dayjs/locale/pt-br"; // Caso queira suportar o formato em português

// --------------------- Import Styles ---------------------
import { ContainerModalArquivo, TextModal, formStyle, layout } from "../styles";
import { useFileUpload } from "../../ViewGerenciarPropriedadeUsuario/hooks/useUploadFiles";
import { UploadOutlined } from "@ant-design/icons";
import { useCadastrarArquivosReserva } from "../hooks/useCadastrarArquivosReserva";
import { useUploadArquivos } from "../hooks/useExecutarUpload";

interface ModalAutorizacaoProps {
  isModalOpen: boolean;
  handleFechar: () => void;
  cotaUsuario: number | null;
  reservaId: number | null;
}

export default function ModalAutorizacao({
  isModalOpen,
  handleFechar,
  cotaUsuario,
  reservaId,
}: ModalAutorizacaoProps) {
  const [dataAutorizacao, setDataAutorizacao] = useState("");

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Erro
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Funçao navigate que é utilizada para o reload da página
  const navigate = useNavigate();

  /* eslint-disable no-template-curly-in-string */ // Constante que válida os campos de todos os  formulário
  const validarFormulario = {
    required: "${label} é necessário!",
  };

  const { cadastrar } = useCadastrarArquivosReserva(reservaId, dataAutorizacao);
  // Usando o hook
  const { fileList, handleRemove, beforeUpload, handleUpload } =
    useFileUpload(cotaUsuario);

  const props: UploadProps = {
    onRemove: handleRemove,
    beforeUpload,
    fileList,
  };

  const autorizacaoOnChange = (changedValues: Partial<any>, allValues: any) => {
    setDataAutorizacao(allValues);
  };

  const { executarUpload, isLoading, successMessage, errorMessage } =
    useUploadArquivos(handleUpload, cadastrar);

  const errorRef = useRef<string | null>(null);

  // Atualiza o valor de errorRef e warningRef toda vez que o error e warning mudar
  useEffect(() => {
    if (errorMessage) {
      errorRef.current = errorMessage;
    }
  }, [errorMessage]);

  // useEffect para lidar com o sucesso
  useEffect(() => {
    if (successMessage && !successDisplayed) {
      showSuccess(successMessage);
      setSuccessDisplayed(true);
      setTimeout(() => {
        navigate(0); // Simula um refresh completo
      }, 4000);
    }
    if (errorRef.current && !errorDisplayed) {
      showError(errorRef.current);
      setErrorDisplayed(true);
      setTimeout(() => {
        errorRef.current = null;
        setErrorDisplayed(false);
      }, 2000);
    }
  }, [
    successMessage,
    showSuccess,
    successDisplayed,
    navigate,
    errorMessage,
    showError,
    errorDisplayed,
  ]);

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      title="Autorizaçao"
      cancelText="Cancelar"
      okText="Incluir"
      onOk={executarUpload}
      confirmLoading={isLoading}
      okButtonProps={{
        style: {
          backgroundColor: "#003644",
          borderColor: "#003644",
          color: "white",
        }, // Botão "Ativar" com fundo verde
      }}
      cancelButtonProps={{
        style: {
          backgroundColor: "#f44336",
          borderColor: "#f44336",
          color: "white",
        }, // Botão "Cancelar" com fundo vermelho
      }}
    >
      <>{errorContextHolder}</>
      <>{successContextHolder}</>
      <p>Inclua a data de autorizaçao e faça o upload em anexo</p>
      <Form
        {...layout}
        onValuesChange={(changedValues, allValues) =>
          autorizacaoOnChange(changedValues, allValues)
        }
        name="reserva-autorizacao"
        style={formStyle}
        validateMessages={validarFormulario}
      >
        {" "}
        <Form.Item
          name={["dataAutorizacao"]}
          label="Data Autorização "
          className="formItems"
        >
          <DatePicker format="DD/MM/YYYY" />
        </Form.Item>
      </Form>
      <ContainerModalArquivo>
        <TextModal>Arquivo de Autorização</TextModal>
        <Upload {...props}>
          <Button icon={<UploadOutlined />}>
            Clique para carregar arquivo
          </Button>
        </Upload>

        {/* <Flex align="center" justify="center">
          <Button
            type="primary"
            onClick={handleUpload}
            loading={uploading}
            style={btnStyle}
            size="large"
          >
            {uploading ? "Uploading" : "Anexar"}
          </Button>
        </Flex> */}
      </ContainerModalArquivo>
    </Modal>
  );
}
